import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_RRHH_REQUEST,
} from '../../actions/constants/rrhh/rrhh.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getRrhhFailureAction,
  getRrhhSuccessAction,
} from '../../actions/creators/rrhh/rrhh.actioncreator';

const getRrhhFromState = state => state.rrhh;

function* getRrhh(action) {
  const { payload } = action;
  const {
    page, start, limit, sede, tipoListado, busqueda, rrhhSeleccionados,
  } = payload;
  let url = `usuarios/?page=${page}&start=${start}&limit=${limit}&total_segun_sede_y_activo=${sede}&tipo_listado=${tipoListado}`;

  const filtros = [];
  const hayBusqueda = busqueda !== null && busqueda !== '';
  if (hayBusqueda) {
    filtros.push({
      property: 'busqueda', value: busqueda, operator: 'like',
    });
  }

  if (rrhhSeleccionados.length > 0) {
    filtros.push({
      property: 'rrhh_seleccionados', value: rrhhSeleccionados, operator: 'in',
    });
  }

  const queryString = encodeURIComponent(JSON.stringify(filtros));
  url += `&filter=${queryString}`;

  const params = {
    url,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      const rrhhFromState = yield select(getRrhhFromState);

      yield put(getRrhhSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getRrhhFailureAction());
    }
  } catch (error) {
    yield put(getRrhhFailureAction(error));
  }
}

export function* getRrhhRequest() {
  yield takeLatest(GET_RRHH_REQUEST, getRrhh);
}
